import {useLocation, useNavigate } from "react-router-dom";

export function Error() {
    const navigate = useNavigate();

    function navigateHome() {
        navigate("/home");
    }

    return (
        <>
            <h3>An error occured!</h3> 
            <button onClick={navigateHome}>OK</button>
        </>
    )
}
